module.exports = __webpack_public_path__ + "img/inst-4.3e844cd1.png";